import { _tableLogActivity } from "lib/Helper";
import Action from "./Action";
import { SettingOutlined } from "@ant-design/icons";

const columns = (action, modalForm, modalDelete) => [
  {
    title: 'No',
    dataIndex: 'rownum',
    width: '5%',
  },
  {
    title: 'Nama Service',
    dataIndex: 'whatsapp_service_name',
    render: (text, row) => text || "-",
  },
  {
    title: 'API Key',
    dataIndex: 'api_key',
    render: (text) => text || "-",
  },
  {
    title: 'Nomor WhatsApp',
    dataIndex: 'wa_number',
    render: (text) => text || "-",
  },
  {
    title: 'Key Number',
    dataIndex: 'key_number',
    render: (text) => text || "-",
  },
  {
    title: 'LogActivity',
    key: 'logactivity',
    width: '10%',
    render: (a, row) => _tableLogActivity(row),
  },
  {
    title: <SettingOutlined />,
    align: "center",
    key: 'operation',
    width: '5%',
    render: (a, row) => (
      <Action
        row={row}
        action={action}
        modalForm={modalForm}
        modalDelete={modalDelete}
      />
    ),
  },
];

export default columns;
